import { useDispatch, useSelector } from "react-redux";
import cancel from "../../../assets/images/tickmark.png";
import { Input } from "../../../components/ui";
import { TRootState } from "../../../store";
import { setApprRejectFields } from "../../../reducers/marketSlice";
import { useEffect } from "react";

const ApproveMarket: React.FC<{
  approveMarketModalStatus: boolean
}> = ({
  approveMarketModalStatus
}) => {

    const dispatch = useDispatch();

    const { apprRejectFields, marketDeatisById } = useSelector((state: TRootState) => ({
      apprRejectFields: state.marketDetails.apprRejectFields,
      marketDeatisById: state.marketDetails.marketDeatisById
    }));

    useEffect(() => {
      if (approveMarketModalStatus) {
        dispatch(setApprRejectFields({
          ...apprRejectFields!,
          empOrs: Number(marketDeatisById?.employee?.ors)
        }))
      }
    }, [approveMarketModalStatus])

    return (
      <div>
        <div className=" flex flex-col gap-4 text-sm ">
          <div className="flex justify-center">
            <img src={cancel} className="w-8 " />
          </div>
          <p className="text-center">
            Are you sure you want to approve this request?
            <br /> Please provide the below required fields.
          </p>
          <div className="space_18 ">
            <div className="flex space_18 gap-4">
              <Input
                label="RM Risk Score "
                type="number"
                // required={true}
                value={apprRejectFields?.empOrs}
                onChange={(e) => {
                  dispatch(setApprRejectFields({
                    ...apprRejectFields!,
                    empOrs: e.target.value
                  }))
                }}
                className="flex-1"
              />
              <Input
                label="Market Risk Score "
                type="number"
                // required={true}
                value={apprRejectFields?.marketOrs}
                onChange={(e) => {
                  dispatch(setApprRejectFields({
                    ...apprRejectFields!,
                    marketOrs: e.target.value
                  }))
                }}
                className="flex-1"
              />
            </div>
          </div>
          <div className="">
            <Input
              label="Remarks (if any)"
              type="text"
              required={false}
              value={apprRejectFields?.approveRemarks}
              className="flex-1"
              onChange={(e) => {
                dispatch(setApprRejectFields({
                  ...apprRejectFields!,
                  approveRemarks: e.target.value
                }))
              }}
              palceholder="Tell why you are approving this request"
            />
          </div>
        </div>
      </div>
    );
  };
export default ApproveMarket;
